import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { MNPInitialization } from './MNPInitialization';
import { MNPActivation } from './MNPActivation';
import { MNPSuccess } from './MNPSuccess';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';
export function ActivationStep3() {
  // Context
  const { step3SubStep, setShowActivationHeader, setShowActivationFooter, getLookup } =
    useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();
  // META: handle page titles
  const { globalPageTitle, globalSuccessPageTitle } = getGlobalMetaTitles();
  const activationMnpApplyPageTitle = tA11yTranslate('ek_global_meta_title_mnp_apply').content;
  const activationMnpPageTitle = tA11yTranslate('ek_global_meta_title_mnp').content;
  const isTranslationReady = keyValueValidation(activationMnpPageTitle, 'ek_global_meta_title_mnp');
  // Determine the page title based on the current substep
  const getPageTitle = () => {
    if (step3SubStep === 1) {
      return `${globalPageTitle} - ${activationMnpApplyPageTitle}`;
    } else if(step3SubStep === 2){
      return `${globalPageTitle} - ${globalSuccessPageTitle}`;
    }else{
      return `${globalPageTitle} - ${activationMnpPageTitle}`;
    }
  };

  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step3SubStep, announceTitle]); // Re-run when substep changes

  // Hooks
  useEffect(() => {
    // Hide footer for below screens
    // 0.1.4.6 - registration step 3 - with MNP success
    if (step3SubStep === 2) {
      setShowActivationHeader(false);
      setShowActivationFooter(false);
    } else {
      setShowActivationFooter(true);
      setShowActivationHeader(true);
    }
  }, [step3SubStep]);

  useEffect(() => {
    getLookup();
  }, []);

  const renderStep3SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <MNPInitialization />;
      case 1:
        return <MNPActivation />;
      case 2:
        return <MNPSuccess />;
      default:
        return <MNPInitialization />;
    }
  };

  return (
    <>
      <Meta title={getPageTitle()} key={`meta-key-${step3SubStep}`} />
      {renderStep3SubSteps(step3SubStep)}
    </>
  );
}

export default ActivationStep3;
